import { Box, Grid, Typography } from "@mui/material";

import { bone, ink, stone } from "../pricing-reports/design/designTokens";

const GLANCE_FIELDS = [
  { key: "unitPrice", label: "Unit price" },
  { key: "price", label: "Total" },
  { key: "weight", label: "Weight" },
];

export default function VerifyPriceGlancePrices({ item }) {
  return (
    <Grid container spacing={1}>
      {GLANCE_FIELDS.map((field) => {
        const value = item?.[field.key];
        const raw = value != null && String(value).trim() !== "" ? String(value) : "—";
        const display = field.key === "unitPrice" ? raw.replace(" per ", " / ") : raw;

        return (
          <Grid key={field.key} item xs={12} sm={4}>
            <Box
              sx={{
                height: "100%",
                px: 1.5,
                py: 1.25,
                backgroundColor: bone,
                border: `1px solid ${stone}`,
              }}
            >
              <Typography
                variant="caption"
                sx={{
                  display: "block",
                  fontWeight: 700,
                  letterSpacing: "0.06em",
                  textTransform: "uppercase",
                  color: ink,
                }}
              >
                {field.label}
              </Typography>
              <Typography sx={{ fontWeight: 800, fontSize: "1.25rem", lineHeight: 1.25, color: ink }}>
                {display}
              </Typography>
            </Box>
          </Grid>
        );
      })}
    </Grid>
  );
}
